import { AchievementInfo } from "./AchievementInfoTypes";

// -----
// *** BRICK PACK ACHIEVEMENTS ***
// -----

// brickpack_sloped_bricks_part_one
export const Achievement_BrickPack_Sloped_10: AchievementInfo = {
  id: "achievement_brickpack_sloped_bricks_part_one_10",
  title: "Sloped Bricks Novice",
  description: "Purchase Sloped Bricks #1 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_sloped_bricks_part_one",
  threshold: 250,
};

export const Achievement_BrickPack_Sloped_50: AchievementInfo = {
  id: "achievement_brickpack_sloped_bricks_part_one_50",
  title: "Sloped Bricks Expert",
  description: "Purchase Sloped Bricks #1 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_sloped_bricks_part_one",
  threshold: 1500,
};

export const Achievement_BrickPack_Sloped_100: AchievementInfo = {
  id: "achievement_brickpack_sloped_bricks_part_one_100",
  title: "Sloped Bricks Master",
  description: "Purchase Sloped Bricks #1 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_sloped_bricks_part_one",
  threshold: 3500,
};

// brickpack_minifig_utensils_part_one
export const Achievement_BrickPack_Minifig_10: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_one_10",
  title: "Minifig Utensils Novice",
  description: "Purchase Minifig Utensils #1 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_one",
  threshold: 250,
};

export const Achievement_BrickPack_Minifig_50: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_one_50",
  title: "Minifig Utensils Expert",
  description: "Purchase Minifig Utensils #1 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_one",
  threshold: 1500,
};

export const Achievement_BrickPack_Minifig_100: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_one_100",
  title: "Minifig Utensils Master",
  description: "Purchase Minifig Utensils #1 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_one",
  threshold: 3500,
};

// brickpack_bionicles_part_one
export const Achievement_BrickPack_Bionicles_10: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_one_10",
  title: "Bionicles Novice",
  description: "Purchase Bionicles #1 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_one",
  threshold: 250,
};

export const Achievement_BrickPack_Bionicles_50: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_one_50",
  title: "Bionicles Expert",
  description: "Purchase Bionicles #1 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_one",
  threshold: 1500,
};

export const Achievement_BrickPack_Bionicles_100: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_one_100",
  title: "Bionicles Master",
  description: "Purchase Bionicles #1 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_one",
  threshold: 3500,
};

// brickpack_animals_part_one
export const Achievement_BrickPack_Animals_10: AchievementInfo = {
  id: "achievement_brickpack_animals_part_one_10",
  title: "Animals Novice",
  description: "Purchase Animals #1 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_animals_part_one",
  threshold: 250,
};

export const Achievement_BrickPack_Animals_50: AchievementInfo = {
  id: "achievement_brickpack_animals_part_one_50",
  title: "Animals Expert",
  description: "Purchase Animals #1 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_animals_part_one",
  threshold: 1500,
};

export const Achievement_BrickPack_Animals_100: AchievementInfo = {
  id: "achievement_brickpack_animals_part_one_100",
  title: "Animals Master",
  description: "Purchase Animals #1 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_animals_part_one",
  threshold: 3500,
};

// brickpack_minifig_utensils_part_two
export const Achievement_BrickPack_Minifig2_10: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_two_10",
  title: "Minifig Utensils #2 Novice",
  description: "Purchase Minifig Utensils #2 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_two",
  threshold: 250,
};

export const Achievement_BrickPack_Minifig2_50: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_two_50",
  title: "Minifig Utensils #2 Expert",
  description: "Purchase Minifig Utensils #2 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_two",
  threshold: 1500,
};

export const Achievement_BrickPack_Minifig2_100: AchievementInfo = {
  id: "achievement_brickpack_minifig_utensils_part_two_100",
  title: "Minifig Utensils #2 Master",
  description: "Purchase Minifig Utensils #2 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_utensils_part_two",
  threshold: 3500,
};

// brickpack_bionicles_part_two
export const Achievement_BrickPack_Bionicles2_10: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_two_10",
  title: "Bionicles #2 Novice",
  description: "Purchase Bionicles #2 pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_two",
  threshold: 250,
};

export const Achievement_BrickPack_Bionicles2_50: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_two_50",
  title: "Bionicles #2 Expert",
  description: "Purchase Bionicles #2 pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_two",
  threshold: 1500,
};

export const Achievement_BrickPack_Bionicles2_100: AchievementInfo = {
  id: "achievement_brickpack_bionicles_part_two_100",
  title: "Bionicles #2 Master",
  description: "Purchase Bionicles #2 pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_bionicles_part_two",
  threshold: 3500,
};

// brickpack_circular_bricks
export const Achievement_BrickPack_Circular_10: AchievementInfo = {
  id: "achievement_brickpack_circular_bricks_10",
  title: "Circular Bricks Novice",
  description: "Purchase Circular Bricks pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_circular_bricks",
  threshold: 250,
};

export const Achievement_BrickPack_Circular_50: AchievementInfo = {
  id: "achievement_brickpack_circular_bricks_50",
  title: "Circular Bricks Expert",
  description: "Purchase Circular Bricks pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_circular_bricks",
  threshold: 1500,
};

export const Achievement_BrickPack_Circular_100: AchievementInfo = {
  id: "achievement_brickpack_circular_bricks_100",
  title: "Circular Bricks Master",
  description: "Purchase Circular Bricks pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_circular_bricks",
  threshold: 3500,
};

// brickpack_minifig_hair
export const Achievement_BrickPack_MinifigHair_10: AchievementInfo = {
  id: "achievement_brickpack_minifig_hair_10",
  title: "Minifig Hair Novice",
  description: "Purchase Minifig Hair pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_hair",
  threshold: 250,
};

export const Achievement_BrickPack_MinifigHair_50: AchievementInfo = {
  id: "achievement_brickpack_minifig_hair_50",
  title: "Minifig Hair Expert",
  description: "Purchase Minifig Hair pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_hair",
  threshold: 1500,
};

export const Achievement_BrickPack_MinifigHair_100: AchievementInfo = {
  id: "achievement_brickpack_minifig_hair_100",
  title: "Minifig Hair Master",
  description: "Purchase Minifig Hair pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_hair",
  threshold: 3500,
};

// brickpack_technic_bricks
export const Achievement_BrickPack_Technic_10: AchievementInfo = {
  id: "achievement_brickpack_technic_bricks_10",
  title: "Technic Bricks Novice",
  description: "Purchase Technic Bricks pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_technic_bricks",
  threshold: 250,
};

export const Achievement_BrickPack_Technic_50: AchievementInfo = {
  id: "achievement_brickpack_technic_bricks_50",
  title: "Technic Bricks Expert",
  description: "Purchase Technic Bricks pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_technic_bricks",
  threshold: 1500,
};

export const Achievement_BrickPack_Technic_100: AchievementInfo = {
  id: "achievement_brickpack_technic_bricks_100",
  title: "Technic Bricks Master",
  description: "Purchase Technic Bricks pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_technic_bricks",
  threshold: 3500,
};

// brickpack_minifig_headgear
export const Achievement_BrickPack_MinifigHeadgear_10: AchievementInfo = {
  id: "achievement_brickpack_minifig_headgear_10",
  title: "Minifig Headgear Novice",
  description: "Purchase Minifig Headgear pack 250 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_headgear",
  threshold: 250,
};

export const Achievement_BrickPack_MinifigHeadgear_50: AchievementInfo = {
  id: "achievement_brickpack_minifig_headgear_50",
  title: "Minifig Headgear Expert",
  description: "Purchase Minifig Headgear pack 1,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_headgear",
  threshold: 1500,
};

export const Achievement_BrickPack_MinifigHeadgear_100: AchievementInfo = {
  id: "achievement_brickpack_minifig_headgear_100",
  title: "Minifig Headgear Master",
  description: "Purchase Minifig Headgear pack 3,500 times",
  category: "brickpack",
  targetType: "specific",
  targetId: "brickpack_minifig_headgear",
  threshold: 3500,
};
